import { render, staticRenderFns } from "./DisplayChecklist.vue?vue&type=template&id=5d50b662&scoped=true"
import script from "./DisplayChecklist.vue?vue&type=script&lang=js"
export * from "./DisplayChecklist.vue?vue&type=script&lang=js"
import style0 from "./DisplayChecklist.vue?vue&type=style&index=0&id=5d50b662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50b662",
  null
  
)

export default component.exports